/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { metaInterestIndex } from '../../axios/metaInterestIndex'
import type {
	MetaInterestIndexError,
	MetaInterestIndexQueryParams,
	MetaInterestIndexResponse,
} from '../../types/MetaInterestIndex'

export const metaInterestIndexQueryKey = (params?: MetaInterestIndexQueryParams) =>
	[{ url: '/meta/interests' }, ...(params ? [params] : [])] as const

export type MetaInterestIndexQueryKey = ReturnType<typeof metaInterestIndexQueryKey>

/** @see backend/nexus/modules/MetaAd/Http/Controllers/MetaInterestController.php MetaInterestController::index */
export function metaInterestIndexQueryOptions(params?: MetaInterestIndexQueryParams, config?: AxiosRequestConfig) {
	return queryOptions<
		MetaInterestIndexResponse,
		AxiosError<MetaInterestIndexError>,
		MetaInterestIndexResponse,
		MetaInterestIndexQueryKey
	>({
		queryKey: metaInterestIndexQueryKey(params),
		queryFn: ({ signal }) => metaInterestIndex(params, { signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/MetaAd/Http/Controllers/MetaInterestController.php MetaInterestController::index */
export function useMetaInterestIndex<TSelectData = MetaInterestIndexResponse>(
	params?: MetaInterestIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					MetaInterestIndexResponse,
					AxiosError<MetaInterestIndexError>,
					TSelectData,
					MetaInterestIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<MetaInterestIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...metaInterestIndexQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/MetaAd/Http/Controllers/MetaInterestController.php MetaInterestController::index */
export function useMetaInterestIndexSuspense<TSelectData = MetaInterestIndexResponse>(
	params?: MetaInterestIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					MetaInterestIndexResponse,
					AxiosError<MetaInterestIndexError>,
					TSelectData,
					MetaInterestIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<MetaInterestIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...metaInterestIndexQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
